import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginAsStoreService {
  public hideMessage = new BehaviorSubject(false);
  public assumedId = '';
  constructor() { }
}
